<template>
    <div class="iframe-container">
        <Loading v-if="!isLoaded" class="iframe-loading" />
        <iframe
            :src="src"
            :title="title"
            :class="[modal && 'iframe-modal', padding && 'padding', border && 'border']"
            :width="width"
            :height="height"
            @load="onLoaded"
            :ariaLabel="title"
            frameborder="0" />
    </div>
</template>

<script lang="ts">
    import { ref, defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import Loading from '@ui/components/Loading/Loading.vue';

    export default defineComponent({
        name: 'Iframe',
        methods: { t },
        components: { Loading },
        props: {
            src: { type: String, required: true },
            title: { type: String },
            modal: { type: Boolean, default: false },
            padding: { type: Boolean, default: true },
            border: { type: Boolean, default: false },
            height: { type: String, default: 'unset' },
            width: { type: String, default: 'unset' },
        },
        setup() {
            const isLoaded = ref<boolean>(false);

            const onLoaded = () => {
                isLoaded.value = true;
            };

            return {
                isLoaded,
                onLoaded,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Iframe.scss';
</style>
